<div class="profile-card">
  <!-- <div class="header">
    <h3>Welcome Back!</h3>
    <p>One step closer to your perfect university.</p>
  </div> -->

  <div class="progress-ring-container">
    <!-- Pure CSS semicircle gauge — no SVG stroke math issues -->
    <div class="gauge-wrap">
      <div class="gauge-bg"></div>
      <div class="gauge-fill"
        [ngStyle]="{'background': 'conic-gradient(from 270deg, #5250ED 0deg ' + (completionPercentage * 1.8) + 'deg, transparent ' + (completionPercentage * 1.8) + 'deg 360deg)'}">
      </div>
      <div class="gauge-mask"></div>
      <div class="gauge-center">
        <span class="pct-num">{{ completionPercentage }}%</span>
        <span class="pct-label">completed</span>
      </div>
    </div>
  </div>

  <ul class="checklist timeline">
    <li *ngFor="let item of completionItems" [class.completed]="item.done">
      <div class="timeline-icon">
        <i class="pi pi-verified" *ngIf="item.done"></i>
        <div class="uncompleted-dot" *ngIf="!item.done"></div>
      </div>
      <div class="timeline-content">{{ item.label }}</div>
    </li>
  </ul>

  <button class="complete-btn" (click)="onCompleteProfile()">
    Complete Profile &rarr;
  </button>
</div>
